<form class="form-horizontal col-xs-12">
  <div class="form-group" *ngFor="let item of transactionTypes">
    <label class="col-xs-2 control-label" [for]="item.transactionType.Name">
      {{ item.transactionType.Name }}
    </label>
    <div class="col-xs-2">
      <app-select
        *ngIf="processingTypeOptions.length > 0"
        #processingTypeList
        [items]="processingTypeOptions"
        [selected]="selectProcessingType(item)"
        [active]="[item.processingType]"
        placeholder="Select a Processing Type"
      >
      </app-select>
    </div>
    <label class="col-xs-2 control-label">Outbound Directory</label>
    <div class="col-xs-4">
      <app-select
        *ngIf="outboundDirectoryOptions.length > 0"
        #outboundDirectoryList
        [items]="outboundDirectoryOptions"
        [selected]="selectOutboundDirectory(item)"
        [active]="[item.outboundDirectory]"
      >
      </app-select>
    </div>
  </div>
  <div>
    <div>
      <h4>Run Validations</h4>
    </div>
    <div class="checkContainer" *ngFor="let item of processorDefinitions">
      <div class="check">
        <input
          type="checkbox"
          [id]="'PD' + item.Id"
          [attr.pdid]="item.Id"
          [disabled]="item.IsSystem"
          [checked]="!isProcessorDefinitionBlocklisted(item.Id)"
          (change)="onProcessorDefinitionChange($event)"
        />
        <label [for]="'PD' + item.Id"></label>
      </div>
      <div id="validationChecks">
        <label [for]="'PD' + item.Id">
          {{ item.Name }}
        </label>
        <div id="showAmount" *ngIf="showAmount(item.Id)">
          <label>*Amount</label>
          <input
            type="text"
            class="form-control"
            oninput="this.value = this.value.replace(/[^0-9.,]/g, '');"
            maxlength="4"
            name="Amount"
            [(ngModel)]="this.highDollarThresholdValue.Value"
            [disabled]="!this.hasHighDollarThresholdEditPermission()"
          />
          <button
            type="submit"
            class="btn btn-success"
            (click)="onSaveAmount()"
            [disabled]="!this.hasHighDollarThresholdEditPermission()"
          >
            Save Amount
          </button>
        </div>
        <div id="showDays" *ngIf="showDays(item.Id)">
          <label>*Days</label>
          <input
            type="text"
            class="form-control"
            oninput="this.value = this.value.replace(/[^0-9.,]/g, '');"
            maxlength="4"
            name="Days"
            [(ngModel)]="this.timelyFilingDays.Value"
            [disabled]="!this.hasTimelyFilingDaysEditPermission()"
          />
          <button
            type="submit"
            class="btn btn-success"
            (click)="onSaveDays()"
            [disabled]="!this.hasTimelyFilingDaysEditPermission()"
          >
            Save Days
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
